import { useEffect } from "react"
import { Link, useParams, useOutletContext } from "react-router-dom"
import { useComputed } from "@preact/signals-react"

import Table from 'react-bootstrap/Table'

import LoadingAnimation from "../../components/LoadingAnimation.jsx"
import TimestampWithUTCTooltip from "../../components/TimestampWithUTCTooltip.jsx"

import { fetchInstallationList } from "../../state/actions/installationActions.js"
import { fetchUserPermissionMasks } from '../../state/actions/permissionActions.js'

import { businessEntitiesLoadedSignal, businessEntityDictionarySignal } from '../../state/signals/businessEntitySignals.js'
import { installationListSignal, installationListLoadedSignal } from "../../state/signals/installationSignals.js"
import { currentUserSignal } from '../../state/signals/userSignals.js'

import { getInstallationTypeString } from '../../utils/utils.js'
import { debugSignal } from "../../state/signals/userSettingsSignals"

function Dashboard() {

	const { beId } = useParams()
	const { config, accessToken, userPermissionsSummary, currentBusinessEntityId, accordionData: sidebarAccordionData } = useOutletContext()
	let referenceGuid = config && config.referenceGuid ? config.referenceGuid : null

	useEffect(() => {
		if (userPermissionsSummary?.value?.canViewInstallations) {
			fetchInstallationList(beId, config, accessToken)
		}
	}, [userPermissionsSummary.value, beId, config, accessToken])

	const sortedDataComputed = useComputed(() => {
		try {
			let _sortedData = [...installationListSignal.value]
			return _sortedData.sort((a, b) => {
				if (a.lastUpdatedAt < b.lastUpdatedAt) {
					return 1
				}
				if (a.lastUpdatedAt > b.lastUpdatedAt) {
					return -1
				}
				return 0
			})
		} catch (x) {
			window.alert(x)
		}
	})

	const displayDataComputed = useComputed(() => {
		return sortedDataComputed.value.slice(0, 5)
	})

	function TableRow({ item }) {
		return (
			<tr>
				<td>{item.manifest.machine.nickname}</td>
				<td>{getInstallationTypeString(item.type)}</td>
				<td>{
					!businessEntitiesLoadedSignal.value ? (
						<LoadingAnimation />
					) : (
						businessEntityDictionarySignal.value[item.businessEntityId].name
					)
				}</td>
				<td><TimestampWithUTCTooltip>{item.lastUpdatedAt}</TimestampWithUTCTooltip></td>
			</tr>
		)
	}

	function debugPermissionMasks(event) {
		event.preventDefault()
		fetchUserPermissionMasks(currentUserSignal.value.id, config, accessToken, true).then(
			(masks) => {
				console.log("Fetched permission masks")
				console.log(masks)
			}
		)
	}

	function TableRows({ items }) {
		if (items && items.length) {
			return items.map(item => {
				return <TableRow item={item} key={`${item.id}`} />
			})
		}
		return (
			<tr><td colSpan="18" className="text-center">No recent installations</td></tr>
		)
	}

	return (
		<div className="dashboard">
			<section hidden className="col-xs-6 col-sm-6 col-md-6 panel" style={{ display: "none" }}>
				<header className="panel-heading">
					<h2 className="panel-title">Alerts</h2>
				</header>
				<div className="panel-body">No Recent Alerts</div>
			</section>
			<section>
				<header>I Want to...</header>
				<div>
					<a target="_blank" rel="noreferrer" href={referenceGuid}>Read the Reference Guide</a>
					{
						userPermissionsSummary.value?.canEditInstallations && (
							<>
								<Link to={{ pathname: `/be/${beId}/installations` }} state={{ intent: 'install' }}>Install and Connect a New UTG</Link>
								<Link to={{ pathname: `/be/${beId}/installations` }} state={{ intent: 'connect' }}>Connect an existing UTG</Link>
							</>
						)
					}
					{
						userPermissionsSummary.value?.canViewInstallations && (
							<Link to={{ pathname: `/be/${beId}/installations` }}>View My Installations</Link>
						)
					}
					{
						userPermissionsSummary.value?.canEditUtgs && (
							<Link to={{ pathname: `/be/${beId}/utgs` }} state={{ intent: 'schedule' }}>Schedule a Task</Link>
						)
					}
					{
						userPermissionsSummary.value?.canViewUtgs && (
							<Link to={{ pathname: `/be/${beId}/utgs` }}>View My UTGs</Link>
						)
					}
				</div>
			</section>
			{
				userPermissionsSummary.value?.canViewInstallations && (
					<section style={{ width: "66.66666667%" }}>
						<header>Recent Installations</header>
						<Table striped hover size="sm" style={{ overflow: 'auto' }}>
							<thead>
								<tr>
									<th>Installation Name</th>
									<th>Install Type</th>
									<th>Parent Account</th>
									<th>Last Updated</th>
								</tr>
							</thead>
							<tbody>{
								(!installationListLoadedSignal.value) ? (
									<tr><td colSpan={4}><LoadingAnimation /></td></tr>
								) : (
									<TableRows items={displayDataComputed.value} />
								)
							}</tbody>
						</Table>
					</section>
				)
			}
			{/*
				debugSignal.value && (
					<div>
						<Loadable loadedSignals={[currentUserLoadedSignal]} errorSignals={[currentUserErrorSignal]}>
							<Button
								onClick={debugPermissionMasks}
							>Fetch permission masks</Button>
						</Loadable>
					</div>
				)
			*/}
		</div>
	)
}

export default Dashboard